import { useReducer } from 'react';

export function useForceUpdate(): any {
  const [ignore, forceUpdate] = useReducer((x) => x + 1, 0);

  return [ignore, forceUpdate];
}
